const urlText = "Здравствуйте! Хочу подробнее узнать об услугах";
export default urlText;
